<template>
  <div class="header-nav-wrapper">
      <div class="container lg:px-0">
        <div class="flex items-center">
            <div class="w-full md:w-3/6 lg:w-5/12">
              <div class="flex justify-center md:justify-start m-auto md:m-0"><router-link to="/"><img src="/images/logo.png"></a></router-link></div>
            </div>
            <div class="w-4/12 hidden lg:block">
              <div class="w-full flex">
                <div class="pr-5">
                  <router-link class="m-auto md:m-0" to="/"><img src="/images/icon-map.jpg"></router-link>
                </div>
                <div>
                  <div class="text-common text-xl leading-tight text-red-600">VISIT US</div>
                  <div class="text-common text-base leading-tight text-gray-800">17 Pangilinan Ave., Pangilinan<br>Compound, Barangay Bahay<br>Toro, Quezon City</div>
                </div>
              </div>
            </div>
            <div class="w-3/6 lg:w-3/12 hidden md:block">
              <div class="w-full flex">
                <div class="pr-5"><img src="/images/icon-tel.jpg"></div>
                <div>
                  <div class="text-common text-xl leading-tight text-red-600">CONTACT US AT</div>
                  <a href="tel:0289287439" target="_blank" class="text-title text-2xl leading-tight text-gray-800 transition-effect hover:text-blue-500">(02) 8 928-7439</a>
                </div>
              </div>
            </div>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'Headernav'
}
</script>

<style>
.header-nav-wrapper {
  background-color: #fff;
  padding: 24px 0px;
}
</style>
